/**
 * @typedef {import('../../services/weather/types/CustomWeather.api_types').Forecast15DayDatapoint} Forecast15DayDatapoint
 */

import { WeatherContext } from 'pages/Forecast';
import React, { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import 'styles/global.css';
import { GetDateSpanString, GetWeatherDateString } from 'utils/stringUtils';
import Day15Display from './Day15Display';
import styles from './Day15Forecast.module.css';

export default function Day15Forecast() {
  const weatherContext = useContext(WeatherContext);
  /** @type {Forecast15DayDatapoint[]} */
  const day15Forecast = weatherContext?.day15 ?? [];

  return (
    <Container fluid className="d-flex flex-column gap-3 h-100 user-select-none px-0">
      {day15Forecast.length > 0 && (
        <div className={styles.header}>
          {`${GetDateSpanString(
            new Date(day15Forecast[0]?.iso8601),
            new Date(day15Forecast[day15Forecast.length - 1]?.iso8601),
          )} Weather Forecast`}
        </div>
      )}

      <div className={[styles.contentContainer, 'overflow-hidden']}>
        <Row className={styles.grid}>
          {day15Forecast.map((item) => (
            <Col xs={12} md={6} key={item?.iso8601} className={styles.gridItem}>
              <Day15Display data={item} title={GetWeatherDateString(new Date(item?.iso8601))} />
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
}
